import { useState } from 'react'
import SubtitleIcon from './subtitleIcon'
import { handleSubtitle } from 'redux-share/actions/videoData.actions'
import { conditions } from 'helpers'
import { ConditionName } from 'interfaces';
import ControllbarTooltip from '../../mainComponent/footer/controllbar/controllbarTooltip';

const Subtitles = () => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false)

  return (
    <div className='pl-relative pl-flex pl-items-center'>
      <SubtitleIcon
        onClick={handleSubtitle}
        onDoubleClick={(event: any) => event.stopPropagation()}
        onMouseOver={() => !conditions(ConditionName.isTouchScreen) && setShowTooltip(true)}
        onMouseLeave={() => !conditions(ConditionName.isTouchScreen) && setShowTooltip(false)}
      />
      {showTooltip && <ControllbarTooltip title='زیرنویس (c)' />}
    </div>
  )

}

export default Subtitles